import { z } from "zod";

export const kvSchema = z.object({
  key: z.string().min(1),
  value: z.string().min(1),
});

export type KVSchema = z.infer<typeof kvSchema>;

export function kvArrayToRecord(
  arr?: KVSchema[],
): Record<string, string> | undefined {
  if (!arr?.length) {
    return undefined;
  }
  return Object.fromEntries(arr.map(kv => [kv.key, kv.value]));
}

export function recordToKVArray(
  record?: Record<string, string> | null,
): KVSchema[] {
  return Object.entries(record ?? {}).map(([key, value]) => ({ key, value }));
}
